// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2024":"df8433b6","3753":"9d9070b5","5062":"88f44b48","5294":"7d3ce2fe","7609":"cd7d84b9","8105":"d1e1bca4","8548":"87803ffd"}[chunkId] + ".chunk.css";
};